import { __extends } from "tslib";
import * as React from 'react';
import { Icon } from '../icon/icon';
import { icon as drag } from '../../icons/processed/drag.svg';
import { Tooltip } from '../tooltip/tooltip';
import { SortableElement, SortableContainer, SortableHandle } from 'react-sortable-hoc';
import { classNames } from '@wix/answers-lib';
// tslint:disable-next-line: max-line-length
var ListDragHandle = /** @class */ (function (_super) {
    __extends(ListDragHandle, _super);
    function ListDragHandle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.shouldRenderWithTooltip = function (disabled) { return !!disabled && typeof disabled !== 'boolean'; };
        return _this;
    }
    ListDragHandle.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var dragIcon = function () { return props.handleElem ? props.handleElem :
            !!props.disabled ? React.createElement(Icon, { className: 'disabled-drag-icon', icon: drag }) :
                React.createElement(Icon, { className: 'drag-icon', icon: drag }); };
        var maybeDisabledDragIcon = function () { return _this.shouldRenderWithTooltip(props.disabled) ?
            (React.createElement("span", { className: 'drag-icon-disabled' },
                React.createElement(Tooltip, { body: props.disabled, relativeToBody: true }, dragIcon()))) : dragIcon(); };
        var DragHandle = SortableHandle(maybeDisabledDragIcon);
        return React.createElement(DragHandle, null);
    };
    return ListDragHandle;
}(React.PureComponent));
export { ListDragHandle };
// tslint:disable-next-line:max-classes-per-file
var SortableList = /** @class */ (function (_super) {
    __extends(SortableList, _super);
    function SortableList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // tslint:disable: max-line-length jsx-no-multiline-js
        _this.sortableItem = SortableElement(function (_a) {
            var value = _a.value, className = _a.className;
            return React.createElement("li", { style: { listStyleType: 'none' }, className: className }, value);
        });
        _this.sortableListComp = SortableContainer(function () {
            return (React.createElement("ul", { className: 'sortable-list-wrapper' }, _this.props.items.map(function (value, index) {
                var _a;
                var isItemDisabled = !!((_a = _this.props.disabledItems) === null || _a === void 0 ? void 0 : _a.includes(index));
                var maybeDisabledCn = isItemDisabled ? 'disabled' : '';
                var SortableItem = _this.sortableItem;
                return (React.createElement(SortableItem, { key: _this.props.itemKeys ? _this.props.itemKeys[index] : "item-" + index, index: index, value: value, disabled: isItemDisabled, className: maybeDisabledCn }));
            })));
        }, { withRef: true });
        _this.onSortEnd = function (positionData) {
            _this.props.onSortEnd(positionData);
        };
        _this.onSortStart = function (sortStart) {
            if (_this.props.onSortStart) {
                _this.props.onSortStart(sortStart);
            }
        };
        return _this;
    }
    SortableList.prototype.render = function () {
        var _this = this;
        var maybeScrollableContainerSelector = this.props.scrollableContainerSelector;
        var useDragHandle = this.props.useDragHandle ? true : false;
        var maybeGetContainer = maybeScrollableContainerSelector ? function () {
            var maybeScrollableContainer = document.querySelector(maybeScrollableContainerSelector);
            if (maybeScrollableContainer) {
                return maybeScrollableContainer;
            }
            else {
                throw new Error("No wrapper element found for selector - " + _this.props.scrollableContainerSelector + ", to be used as a scrollable container");
            }
        } : undefined;
        return (React.createElement(this.sortableListComp, { helperClass: classNames('sortable-list-ghost', this.props.sortableGhostHelperClass), onSortEnd: this.onSortEnd, distance: this.props.distance, onSortStart: this.onSortStart, useDragHandle: useDragHandle, getContainer: maybeGetContainer, getHelperDimensions: this.props.getHelperDimensions }));
    };
    return SortableList;
}(React.Component));
export { SortableList };
//# sourceMappingURL=index.js.map